import { ISelectOption } from '@apps-common/types/form'

export const MANAGEMENT_PRODUCTS: ISelectOption = {
  label: 'Products',
  value: 'products'
}

export const MANAGEMENT_COMPANIES: ISelectOption = {
  label: 'Companies',
  value: 'companies'
}

export const MANAGEMENT_CONTACTS: ISelectOption = {
  label: 'Contacts',
  value: 'contacts'
}

export const MANAGEMENT_UNIT_FIRMWARE: ISelectOption = {
  label: 'Firmware',
  value: 'device firmware'
}

export const MANAGEMENT_UNIT_PLANS: ISelectOption = {
  label: 'Plans',
  value: 'device plans'
}

export const MANAGEMENT_NON_ALLOCATED_SIMS: ISelectOption = {
  label: 'N/A Sims',
  value: 'non-allocated sims'
}

export const MANAGEMENT_SIM_APNS: ISelectOption = {
  label: 'APNs',
  value: 'sim apns'
}

export const MANAGEMENT_SIM_TYPES: ISelectOption = {
  label: 'Sim Types',
  value: 'sim types'
}

export const MANAGEMENT_REPORTING: ISelectOption = {
  label: 'Reporting',
  value: 'reporting'
}

export const MANAGEMENT_VIEW_OPTIONS: ISelectOption[] = [
  MANAGEMENT_PRODUCTS,
  MANAGEMENT_COMPANIES,
  MANAGEMENT_CONTACTS,
  MANAGEMENT_UNIT_FIRMWARE,
  MANAGEMENT_UNIT_PLANS,
  MANAGEMENT_NON_ALLOCATED_SIMS,
  MANAGEMENT_SIM_APNS,
  MANAGEMENT_SIM_TYPES,
  MANAGEMENT_REPORTING
]
